import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { SearchEngineService, KeplerCoveoService } from '@services';
import { firstValueFrom } from 'rxjs';
import { environment } from '@environments/environment';

export const searchEngineGuard: CanActivateFn = async () => {
    const searchEngineService = inject(SearchEngineService);
    const keplerCoveoService = inject(KeplerCoveoService);

    if (searchEngineService.isInitialized()) {
        return true;
    }

    try {
        const token = await firstValueFrom(
            keplerCoveoService.searchToken$(environment.gknSearch.searchEngineConfiguration.searchHub),
        );
        searchEngineService.init(token);
        return true;
    } catch (error) {
        console.error('Failed to initialize search engine:', error);
        return false;
    }
};
